define(["app/modules/filteringList"], function(FilteringList) {
  var Magazines = function() {};

  Magazines.prototype.actionIndex = function() {
    var onSuccess = this.updateList.bind(this);

    new FilteringList({
      onSuccess: onSuccess
    });
  };

  Magazines.prototype.updateList = function(results) {
    var $grid = $(".js-filtering-list");

    if (results.companies_html) {
      if (results.clear_content) {
        $grid.html(results.companies_html);
      } else {
        var $items = $(results.companies_html);
        $grid.append($items);
      }
    }
  };

  return Magazines;
});
